import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlidesTall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"slides-tall"} maskId="square-filled-radius-0-stroke-1-IconSlidesTall"><path fillRule="evenodd" clipRule="evenodd" d="M4 2V18H8V22H20V6H16V2H4ZM15 6V3H5V17H8V6H15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSlidesTall;
